import { render, staticRenderFns } from "./Currentbasis.vue?vue&type=template&id=82f7779c&scoped=true&"
import script from "./Currentbasis.vue?vue&type=script&lang=js&"
export * from "./Currentbasis.vue?vue&type=script&lang=js&"
import style0 from "./Currentbasis.vue?vue&type=style&index=0&id=82f7779c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f7779c",
  null
  
)

export default component.exports